import type { ReactNode } from 'react';

import { cn } from '../cn';

export function Kbd({ children, tone = 'default', className }: { children: ReactNode; tone?: 'default' | 'inverse'; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-4.5 min-w-4.5 items-center justify-center rounded-sm border px-1 font-sans text-meta leading-none',
        tone === 'default' ? 'border-border-strong bg-surface text-ink-secondary' : 'border-white/30 text-primary-foreground/80',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
